import * as React from "react";
const SvgRight = (props) => /* @__PURE__ */ React.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", fill: "#0B4566", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M17 24.59L21.58 20L17 15.41L18.41 14L24.41 20L18.41 26L17 24.59Z", fill: "#0B4566" }));
export default SvgRight;
